import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { ExtendedDosageFormController } from '../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm.types';

import { DosageTemplatesCreateTemplateButton } from './DosageTemplatesCreateTemplateButton';
import { DosageTemplatesUpdateTemplateButton } from './DosageTemplatesUpdateTemplateButton';

type DosageTemplatesSendTemplateButtonProps = {
   handleSubmit: ExtendedDosageFormController['handleSubmit'];
   disabled: boolean;
   onSuccess: PromiseVoidFunction;
};

export const DosageTemplatesSendTemplateButton = FormsTemplates.withTemplateSaveButton<DosageTemplatesSendTemplateButtonProps>(
   DosageTemplatesCreateTemplateButton,
   DosageTemplatesUpdateTemplateButton
);
